/* Just Cook It – theme interactions */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mobile navigation ---- */
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const overlay = document.querySelector('[data-overlay]');
  const closeBtn = document.querySelector('[data-menu-close]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    toggle && toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    toggle && toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  toggle && toggle.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* ---- Header: scroll shadow + mobile search toggle ---- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchForm = header.querySelector('[data-header-search]');
    if (searchToggle && searchForm) {
      searchToggle.addEventListener('click', function () {
        const open = header.classList.toggle('search-open');
        if (open) searchForm.querySelector('input[type=search]').focus();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') header.classList.remove('search-open');
      });
    }
  }

  /* ---- Hero slideshow ---- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    const speed = parseInt(root.getAttribute('data-speed'), 10) || 7000;
    const autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;

    function go(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        const active = i === index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = active ? 0 : -1; });
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        if (i === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function start() { if (autoplay) { stop(); timer = setInterval(function () { go(index + 1); }, speed); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    const prev = root.querySelector('[data-slide-prev]');
    const next = root.querySelector('[data-slide-next]');
    prev && prev.addEventListener('click', function () { go(index - 1); start(); });
    next && next.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-dot'), 10)); start(); });
    });

    // Pause while the visitor is reading or interacting.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Swipe on touch screens.
    let touchX = null;
    root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      touchX = null;
      start();
    });

    // Theme editor: show the slide being edited.
    document.addEventListener('shopify:block:select', function (e) {
      const i = slides.indexOf(e.target);
      if (i > -1) { stop(); go(i); }
    });

    start();
  });

  /* ---- Carousels (product rows, collections, posts) ---- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    const track = root.querySelector('[data-carousel-track]');
    const nav = root.querySelector('[data-carousel-nav]');
    if (!track || !nav) return;
    const prev = nav.querySelector('[data-carousel-prev]');
    const next = nav.querySelector('[data-carousel-next]');

    function update() {
      const max = track.scrollWidth - track.clientWidth;
      nav.classList.toggle('is-hidden', max <= 4);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }
    function step(dir) {
      const slide = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const width = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      const perView = Math.max(1, Math.round(track.clientWidth / width));
      track.scrollBy({ left: dir * width * perView, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---- Scroll reveal ---- */
  const revealables = document.querySelectorAll('[data-reveal]');
  if (document.body.classList.contains('has-animations') && 'IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add('is-revealed'); });
  }
  // Sections added in the theme editor would otherwise stay hidden.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  });

  /* ---- Product gallery ---- */
  const thumbs = document.querySelectorAll('[data-thumb]');
  const mainImg = document.querySelector('[data-main-image]');
  const gallery = document.querySelector('.product__gallery');

  // The frame width is derived from --cover-aspect, so a swapped-in image with a
  // different ratio has to update it or the thumbnail rail drifts off the cover.
  function syncCoverAspect() {
    if (!gallery || !mainImg || !mainImg.naturalHeight) return;
    gallery.style.setProperty('--cover-aspect', mainImg.naturalWidth / mainImg.naturalHeight);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      const full = t.getAttribute('data-full');
      if (mainImg && full) {
        mainImg.addEventListener('load', syncCoverAspect, { once: true });
        mainImg.src = full;
      }
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        let val = parseInt(input.value, 10) || 1;
        val = Math.max(1, val + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Variant selection ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    const data = form.querySelector('[data-variant-json]');
    if (!data) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    const selects = form.querySelectorAll('[data-option-selector]');
    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const addBtn = form.querySelector('[data-add-to-cart]');

    function currentOptions() {
      return Array.from(selects).map(function (s) { return s.value; });
    }
    function update() {
      const opts = currentOptions();
      const match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.querySelector('[data-add-label]').textContent =
          match.available ? addBtn.getAttribute('data-add-text') : addBtn.getAttribute('data-sold-text');
      }
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  /* ---- Cart helpers ---- */
  const toast = document.querySelector('[data-toast]');
  let toastTimer = null;
  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4200);
  }
  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.hidden = true; }, 400);
  }
  const toastClose = document.querySelector('[data-toast-close]');
  toastClose && toastClose.addEventListener('click', hideToast);

  /* Re-render the header's cart pill through the Section Rendering API, so the
     total is formatted by Shopify in the shop's own currency and locale. */
  function refreshCart() {
    const hdr = document.querySelector('[data-header]');
    const id = hdr && hdr.getAttribute('data-section-id');
    if (!id) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        const doc = new DOMParser().parseFromString(json[id], 'text/html');
        const fresh = doc.querySelector('[data-cart-pill]');
        const current = document.querySelector('[data-cart-pill]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* target is { id: <line item key> } or { line: <1-based index> } */
  function setLineQuantity(target, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ quantity: quantity }, target))
    });
  }

  function addToCart(form) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (item) {
        /* Digital downloads are single-copy: never let repeat adds stack. */
        if (form.getAttribute('data-digital') === 'true' && item && item.quantity > 1) {
          return setLineQuantity({ id: item.key }, 1).catch(function () {});
        }
      })
      .then(refreshCart);
  }

  /* ---- Product page add to cart ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const addBtn = form.querySelector('[data-add-to-cart]');
      if (!addBtn || addBtn.getAttribute('data-ajax') !== 'true') return;
      e.preventDefault();
      addBtn.classList.add('is-loading');
      addToCart(form)
        .then(function () {
          const label = addBtn.querySelector('[data-add-label]');
          const original = label.textContent;
          label.textContent = '✓';
          setTimeout(function () { label.textContent = original; }, 1600);
          addBtn.classList.remove('is-loading');
          showToast();
        })
        .catch(function () { addBtn.classList.remove('is-loading'); form.submit(); });
    });
  });

  /* ---- Product card quick add ---- */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.card__quick');
    btn && btn.classList.add('is-loading');
    addToCart(form)
      .then(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        }
        showToast();
      })
      .catch(function () { btn && btn.classList.remove('is-loading'); form.submit(); });
  });

  /* ---- Mobile sticky add-to-cart bar ---- */
  const stickyBuy = document.querySelector('[data-sticky-buy]');
  const mainBuy = document.querySelector('[data-main-buy]');
  if (stickyBuy && mainBuy && 'IntersectionObserver' in window) {
    const stickyBtn = stickyBuy.querySelector('button');
    new IntersectionObserver(function (entries) {
      const e = entries[0];
      // Only once the button has scrolled up past the top, not before reaching it.
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBuy.classList.toggle('is-visible', show);
      stickyBuy.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    }).observe(mainBuy);
  }

  /* ---- Cart line item quantity / remove ---- */
  document.querySelectorAll('[data-cart-change]').forEach(function (el) {
    el.addEventListener('change', function () {
      const line = el.getAttribute('data-line');
      const qty = el.value;
      window.location.href = '/cart/change?line=' + line + '&quantity=' + qty;
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const line = btn.getAttribute('data-line');
      window.location.href = '/cart/change?line=' + line + '&quantity=0';
    });
  });

  /* Repair carts that stacked digital copies before single-copy enforcement. */
  const stackedDigital = Array.from(document.querySelectorAll('[data-digital-line]')).filter(function (el) {
    return (parseInt(el.getAttribute('data-quantity'), 10) || 1) > 1;
  });
  if (stackedDigital.length) {
    stackedDigital.reduce(function (chain, el) {
      return chain.then(function () {
        return setLineQuantity({ line: parseInt(el.getAttribute('data-line'), 10) }, 1);
      });
    }, Promise.resolve()).then(function () { window.location.reload(); }).catch(function () {});
  }
})();
